import { observable, action, reaction } from 'mobx';
import moment from 'moment';
import {
    ToDateTimeFormat
} from '../utils/date-helper';

class CommonStore{
    @observable token = window.localStorage.getItem("jwt");
    @observable refreshToken = window.localStorage.getItem("refreshToken");
    @observable lastLogin = window.localStorage.getItem("lastLogin");

    @observable appReady = false;

    @observable history = undefined;

    constructor() {
        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem("jwt", token);
                    window.localStorage.setItem("lastLogin", ToDateTimeFormat(moment()) )
                } else {
                    window.localStorage.removeItem("jwt");
                }
            }
        );

        reaction(
            () => this.refreshToken,
            refreshToken => {
                if (refreshToken) {
                    window.localStorage.setItem("refreshToken", refreshToken);
                } else {
                    window.localStorage.removeItem("refreshToken");
                }
            }
        );
    }

    @action
    setAppReady(){
        this.appReady = true;
    }

    @action
    setHistory(history){
        this.history = history;
    }

    @action
    setToken(token, refreshToken) {
        this.token = token;
        this.refreshToken = refreshToken;
        this.lastLogin = ToDateTimeFormat(moment());
    }
}

export default new CommonStore();